import { render, staticRenderFns } from "./CreateCustomFieldSidebar.vue?vue&type=template&id=b98c66a0&scoped=true"
import script from "./CreateCustomFieldSidebar.vue?vue&type=script&lang=js"
export * from "./CreateCustomFieldSidebar.vue?vue&type=script&lang=js"
import style0 from "./CreateCustomFieldSidebar.vue?vue&type=style&index=0&id=b98c66a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b98c66a0",
  null
  
)

export default component.exports